<template>
    <div class="row" :class="{ 'has-danger' : error !== null, 'form-group': !noFormGroup }">
        <label :class="labelClasses" class="form-control-label  col-form-label" :for="name">{{ labelComputed }}</label>
        <div :class="inputHolderClasses">
            <multi-select
                v-bind="$attrs"
                ref="select"
                :id="name"
                :options="options"
                :placeholder="placeholderText"
                :label="objectNameKey"
                :selectedLabel="selectedLabel"
                :selectLabel="selectLabel"
                :deselectLabel="deselectLabel"
                :required="required"
                :value="valueComputed"
                :track-by="trackBy"
                @select="onSelect"
                @input="handleInput"
                autocomplete="off"
            >
                <p slot="noResult">{{ uLang('app.no_results_found_change_query') }}</p>
            </multi-select>
            <span class="help-block form-control-feedback" v-if="error != null" v-text="error"></span>
        </div>
    </div>
</template>

<script>
    import MultiSelect from 'vue-multiselect';

    export default {
        name: 'label-select',

        components: {
            MultiSelect,
        },

        props: {
            options: {
                type: Array,
                required: true,
            },
            trackBy: {
                type: String,
                required: false
            },
            value: {
                default: null,
            },
            error: {
                type: String,
                default: null,
            },
            name: {
                type: String,
                default: null,
            },
            label: {
                type: String,
                default: null,
            },
            objectNameKey: {
                type: String,
                required: false,
                default: 'name',
            },
            objectValueKey: {
                type: String,
                default: null,
            },
            selectLabel: {
                required: false,
                type: String,
                default: function() {
                    return this.uLang('app.press_enter_to_select')
                },
            },
            deselectLabel: {
                required: false,
                type: String,
                default: function() {
                    return this.uLang('app.press_enter_to_deselect')
                },
            },
            selectedLabel: {
                type: String,
                default: function() {
                    return this.uLang('app.select')
                },
            },
            noFormGroup: {
                type: Boolean,
                required: false,
                default: false,
            },
            labelClasses: {
                type: String,
                required: false,
                default: 'col-md-3 col-xl-2 col-sm-12',
            },
            inputHolderClasses: {
                type: String,
                required: false,
                default: 'col-md-9 col-xl-10 col-sm-12'
            },
            noLabel: {
                type: Boolean,
                default: false,
            },
            placeholder: {
                type: String,
                default: null,
            },
            required: {
                type: Boolean,
                default: false,
            },
            onSelect: {
                type: Function,
                default: () => {},
            },
        },
        computed: {
            placeholderText() {
                return this.placeholder || this.uLang('app.select_an_option');
            },
            labelComputed() {
                let label = this.name !== null ? this.uLang('app.' + this.name) : '';

                if (this.label !== null) {
                    label = this.label;
                }

                return label + ': ' + (this.required ? '*' : '');
            },
            valueComputed() {
                if (this.objectValueKey !== null) {
                    const selected = this.options.find((option) => {
                        return option[this.objectValueKey] === this.value;
                    });

                    return selected
                }
                
                return value;
            }
        },

        methods: {
            handleInput(event) {
                if (this.objectValueKey !== null) {
                    this.$emit('input', $getIfExists(event, this.objectValueKey, event));
                    return;
                }

                return this.$emit('input', event);
            },
        },
    }
</script>

<style lang="css">
</style>
